export const baseUrl = 'api/dumpster';
export const baseRelationUrl = `${baseUrl}/relation`;

export const dumpsterById = (id: string) => `${baseUrl}/v2/${id}`;

export const setChildUrl = (id: string) => `${baseRelationUrl}/${id}/new`;
export const removeChildUrl = (id: string) => `${baseRelationUrl}/${id}/remove`;
export const getRelationChildUrl = () => `${baseRelationUrl}/child`;

export const gpsInfoPath = (dumpsterId: string) => `${baseUrl}/${dumpsterId}/gps`;
export const forcePositionPath = (supplierId: string, code: string) => `${baseUrl}/force/${supplierId}/${code}/position`;